// Others
import axiosClient from './axiosClient';
import { urlApiCategory } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { ICategory, IQueryGetListCategory } from '~/utils/interface/category';

const categoryApi = {
  getListCategory: (params: IQueryGetListCategory) => {
    const url = urlApiCategory.getListCategory;
    return axiosClient.get<IBaseResponse<IListDataResponse<ICategory[]>>>(url, { params });
  },
};

export default categoryApi;
